module.exports = function (done, value) {
  return { value: value, done: !!done };
};



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_iter-step.js